import React from 'react'
import Page from './Page'
import { Button, Card, CardBody, CardHeader, Col, Label, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, TabContent, TabPane, Form, FormFeedback, FormGroup, FormText, Input } from 'reactstrap'
// import axios from 'axios';
import axios from '../utils/posAxios'
import StorageService from '../services/StorageService'
import { MdCameraAlt, MdFace, MdDone, MdClear, MdCreate } from 'react-icons/md'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Redirect } from 'react-router'
import PosCategoryForm from './PosCategoryForm'
import PosSupplierForm from './PosSupplierForm'
import { BsPlusSquareFill, BsFiletypeXlsx } from 'react-icons/bs'
import { IconContext } from 'react-icons/lib'
import {utils, writeFile} from 'xlsx';

class PosMaterialTable extends React.Component {
  _isMounted = true
  constructor(props) {
    super(props)
    this.state = {
      modal: false,
      conformModal: false,
      isLoading: true,
      dataList: [],
      storeList: this.props.data.storeList,
      selectedId: '',
      selectedData: '',
      redirect: false,
    }
  }

  toggle = (action, id) => () => {
    return this.setState({
      modal: !this.state.modal,
      isEdit: id != undefined || (id != null && action == 'EDIT') ? true : false,
      selectedId: id != undefined || (id != null && action == 'EDIT') ? id : '',
    })
  }

  toggleConfirmModal = (name, id) => () => {
    return this.setState({
      confirmModal: !this.state.confirmModal,
      selectedData: name,
      selectedId: id,
    })
  }

  closeModal = (title, message, level, reload) => {
    this.notificationSystem.addNotification({
      title: title,
      message: message,
      level: level,
      position: 'br',
      autoDismiss: 2,
      dismissible: 'click',
    })

    this.setState({
      modal: false,
    })

    if (reload) {
      window.location.reload()
    } else {
      this.getData()
    }
  }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    })
  }

  getData = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    }

    axios
      .post(url + ':3002/v1/product/material', data)
      .then(response => {
        const result = response.data
        console.log(result);
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          this.setState({
            isLoading: false,
            dataList: result.data,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  delete = () => {
    const user = StorageService.getSession('user_info')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      id: this.state.selectedId,
      delete_by: user.email,
    }

    axios
      .post(url + ':3002/v1/product/supplier/delete', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          })
          return
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Supplier deleted successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({ confirmModal: false })
        this.getData()
      })
      .catch(error => {
        alert(error)
      })
  }

  componentDidMount() {
    this.getData()
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  detail = id => {
    this.props.history.push({
      pathname: '/posproduct/supplier/' + id,
    })
  }

  exportToExcel = () => {
    const {dataList} = this.state;
    const exportData = dataList.map(item => ({
      'Category':item.category,
      'Product No':item.product_no,
      'Name' : `${item.name } (${item.chn_name})`,
      'Product Type': item.product_type,
      'Material Code': item.material_code,
      'Material Qty': item.qty
    }))

    const worksheet = utils.json_to_sheet(exportData);
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, 'Materials');

    writeFile(workbook, 'materials.xlsx');
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />
    }

    return (
      <>
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />
        <div className="text-right mb-4">
          <div className="ps-btn-group">
            <Button color='link' onClick={this.exportToExcel}>
              
              <IconContext.Provider value={{ color: '#2a2c6b' }}>
                <BsFiletypeXlsx size={25} />
              </IconContext.Provider>
            </Button>
          </div>
        </div>
        <Table responsive hover className="ps-table tb-col-6">
          <thead>
            <tr>
              <th>Category</th>
              <th>Product No</th>
              <th>Name</th>
              <th>Product Type</th>
              <th>Material Code</th>
              <th>Material Qty</th>
            </tr>
          </thead>
          <tbody>
            {this.state.dataList.length < 1 && (
              <tr>
                <td colSpan="6">
                  <div className="ps-empty-data">
                    <div className="empty-content">
                      <MdCreate />
                      <h4>No data to show</h4>
                      <span>Click the 'Create' button to add new supplier</span>
                    </div>
                  </div>
                </td>
              </tr>
            )}

            {this.state.dataList &&
              this.state.dataList.length > 0 &&
              this.state.dataList.map(item => {
                return (
                  <tr key={item.id}>
                    <td>{item.category}</td>
                    <td>{item.product_no}</td>
                    <td>{item.name + ' (' + item.chn_name +')'}</td>
                    <td>{item.product_type}</td>
                    <td>{item.material_code}</td>
                    <td>{item.qty}</td>
                  </tr>
                )
              })}
          </tbody>
        </Table>

        <Modal isOpen={this.state.modal} toggle={this.toggle()} className={this.props.className} centered>
          <PosSupplierForm history={this.props.history} onToggleModal={this.toggle} closeModal={this.closeModal} match={this.props.match} data={this.state} />
        </Modal>
        <Modal isOpen={this.state.confirmModal} toggle={this.toggleConfirmModal()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <ModalHeader toggle={this.toggleConfirmModal()}>Delete Supplier</ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <p>Are you sure you want to delete {this.state.selectedData} ?</p>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button className="theme-button theme-button-secondary" onClick={this.toggleConfirmModal()}>
              No
            </Button>
            <Button className="theme-button theme-button-primary" onClick={() => this.delete()}>
              Yes
            </Button>
          </ModalFooter>
        </Modal>
      </>
    )
  }
}
export default PosMaterialTable
